import Secret from "@/utils/secret.js";
import axios from "axios";

export function getQueryString(name) {
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  let r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return unescape(r[2]);
  }
  return null;
}

// 请求带加密解密
export async function httpPostSecret(url, params={}) {
  const headers = {
    secret: Secret.getAesKey(Secret.privateKey),
    "Content-Type": "text/plain",
  };

  params = Secret.Encrypt(JSON.stringify(params), Secret.privateKey);
  let res = await axios.post(url, params, { headers });
//   console.log(22, Secret.Decrypt(res, Secret.privateKey));
  res = JSON.parse(Secret.Decrypt(res, Secret.privateKey));
  // console.log(24, url, res);
  return res;
}
